export default {
  inserted: function inserted(el, _ref) {
    var _ref$value = _ref.value,
      time = _ref$value === void 0 ? 2000 : _ref$value;
    el.addEventListener("click", function (e) {
      el.classList.add("is-disabled");
      el.disabled = true;
      setTimeout(function () {
        el.disabled = false;
        el.classList.remove("is-disabled");
      }, time);
    });
  }
};